// src/context/AuthContext.js
import { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { getMemberByEmail } from '../api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user,         setUser]         = useState(null);
  const [member,       setMember]       = useState(null);
  const [role,         setRole]         = useState(null);
  const [boardingHouse,setBoardingHouse]= useState(null);
  const [firstLogin,   setFirstLogin]   = useState(false);
  const [loading,      setLoading]      = useState(true);
  const [authError,    setAuthError]    = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        try {
          // Check this email is a registered member
          const result = await getMemberByEmail(firebaseUser.email);

          if (!result.member) {
            // Email not in Sheet — sign them out
            await auth.signOut();
            setAuthError('Your email is not registered. Please contact your house representative.');
            setUser(null);
            setLoading(false);
            return;
          }

          setUser(firebaseUser);
          setMember(result.member);
          setRole(result.member.role);
          setBoardingHouse(result.member.boardingHouse);
          // Check if they signed in with Google
const usedGoogle = firebaseUser.providerData
  .some(p => p.providerId === 'google.com');

// If Google sign-in, skip forced password change
// and mark first login complete automatically
if (usedGoogle && (
  result.member.firstLogin === true ||
  result.member.firstLogin === 'TRUE'
)) {
  // Mark first login complete in the Sheet
  // so they don't get asked again
  try {
    const { markFirstLoginComplete } = await import('../api');
    await markFirstLoginComplete();
  } catch (err) {
    console.error('Could not mark first login:', err);
  }
  setFirstLogin(false);
} else {
  setFirstLogin(
    result.member.firstLogin === true ||
    result.member.firstLogin === 'TRUE'
  );
}
          setAuthError(null);

        } catch (err) {
          console.error('Auth error:', err);
          setAuthError('Login failed. Please try again.');
          setUser(null);
        }
      } else {
        setUser(null);
        setMember(null);
        setRole(null);
        setBoardingHouse(null);
        setFirstLogin(false);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={{
      user, member, role, boardingHouse,
      firstLogin, setFirstLogin,
      loading, authError, setAuthError
    }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);